export const SystemSupportedAccountTypes = {
  admin: {
    id: 'admin',
    path: 'admin_account.id',
  },
};

export const profileTypes = {
  admin: 'a',
};

export const AvailableRoleItemActionDef = {
  view: '_view',
  edit: '_edit',
  create: '_create',
  delete: '_delete',
};

export const defaultProfilePic = 'assets/avatar.png';
